var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._b({tag:"component",class:[
        'flex items-center gap-3 px-4 py-3 text-sm transition-colors',
        _vm.isActive
            ? 'bg-theme-primary text-theme-inverse'
            : 'text-theme-base hover:bg-theme-hover'
    ]},'component',_vm.tagProps,false),[(_vm.$slots.icon)?_c('span',{staticClass:"flex-shrink-0"},[_vm._t("icon")],2):_vm._e(),_c('span',{staticClass:"flex-1 truncate"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }